import {
  useAppInsightsContext,
  useTrackEvent,
} from "@microsoft/applicationinsights-react-js";

export default function useTrackEvents(name: string, data: any) {
  const appInsights = useAppInsightsContext();
  return useTrackEvent(appInsights, name, data, true);
}
